module.exports = __webpack_public_path__ + "static/media/7.8a14a89a.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hairfront/7.png
// module id = 716
// module chunks = 0